import React from 'react';

import Image from '@atlaskit/image';
import Link from '@atlaskit/link';
import { Box, Inline, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import type { Report } from '../../types';
import { ActionsDropdownComponent } from '../thumbnail-actions-dropdown';

export const ThumbnailCard = ({ id, thumbnail, title, link, actions }: Report) => {
	return (
		<Link href={link} appearance="subtle">
			<Box xcss={container}>
				<Box xcss={imageContainer}>
					<Image src={thumbnail} alt={title} />
				</Box>
				<Box xcss={contentContainer}>
					<Inline grow="fill" xcss={thumbnailNameAndActionStyles}>
						<Box>
							{title.length > 25 ? (
								<Tooltip content={title} position="bottom">
									<Text maxLines={1} size="medium" weight="bold">
										{title}
									</Text>
								</Tooltip>
							) : (
								<Text maxLines={1} size="medium" weight="bold">
									{title}
								</Text>
							)}
						</Box>
						<Box xcss={actionsDropdownWrapper}>
							{actions && actions?.length > 0 && <ActionsDropdownComponent actions={actions} />}
						</Box>
					</Inline>
				</Box>
			</Box>
		</Link>
	);
};

const container = xcss({
	display: 'flex',
	width: '244px',
	minWidth: '244px',
	flexDirection: 'column',
	justifyContent: 'flex-start',
	borderRadius: token('space.050'),
	cursor: 'pointer',
	outline: `1px solid ${token('color.background.accent.gray.subtler')}`,
	':hover': {
		outline: `2px solid ${token('color.link')}`,
	},
});

const imageContainer = xcss({
	width: '100%',
	height: '127px',
	background: token('color.background.accent.gray.subtler'),
});

const contentContainer = xcss({
	borderTop: `1px solid ${token('color.border')}`,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
	padding: 'space.200',
});

const thumbnailNameAndActionStyles = xcss({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
});

const actionsDropdownWrapper = xcss({
	display: 'flex',
	alignItems: 'center',
	height: '20px',
	maxHeight: '20px',
});
